import { analytics } from '../../Helpers/Analytics';
import { buildProveAuthEvent, buildProvePrefillFallbackEvent, buildProveStepEvent } from './proveAnalyticsEvents';
import type { ProveAuthAction, ProveAuthMethod, ProveFallbackAction, ProveFallbackReason, ProveFlowType, ProveStepEventInput } from './proveAnalyticsEvents';

export {
  buildProveAuthEvent,
  buildProvePrefillFallbackEvent,
  buildProveStepEvent,
  getProveFallbackReason,
  getProveStartFallbackReason,
  toProveCustomerType,
} from './proveAnalyticsEvents';
export type {
  ProveAnalyticsEvent,
  ProveAuthAction,
  ProveAuthFallbackReason,
  ProveAuthMethod,
  ProveFallbackAction,
  ProveFallbackReason,
  ProveFlowType,
  ProveStepAction,
  ProveStepEventInput,
} from './proveAnalyticsEvents';

export const trackProveStep = (input: ProveStepEventInput) => {
  try {
    const { event, properties } = buildProveStepEvent(input);

    analytics.track(event, properties);
  } catch (error) {
    if (import.meta.env.DEV) console.warn('Prove step tracking failed.', error);
  }
};

export const trackProvePrefillFallback = ({ fallbackAction, fallbackReason, flowType, associate }: { fallbackAction: ProveFallbackAction; fallbackReason?: ProveFallbackReason; flowType: ProveFlowType; associate?: boolean }) => {
  try {
    const { event, properties: eventProperties } = buildProvePrefillFallbackEvent({ fallbackAction, fallbackReason, flowType, associate });

    analytics.track(event, eventProperties);
  } catch (error) {
    if (import.meta.env.DEV) console.warn('Prove fallback tracking failed.', error);
  }
};

export const trackProveAuth = ({ action, associate, flowType, method, properties = {} }: { action: ProveAuthAction; associate?: boolean; flowType: ProveFlowType; method?: ProveAuthMethod; properties?: Record<string, unknown> }) => {
  try {
    const { event, properties: eventProperties } = buildProveAuthEvent({ action, associate, flowType, method, properties });

    analytics.track(event, eventProperties);
  } catch (error) {
    if (import.meta.env.DEV) console.warn('Prove auth tracking failed.', error);
  }
};
